import { createInjectionKey } from "../../_utils/index.mjs";
export const defaultSpan = 1;
export const gridInjectionKey = createInjectionKey('n-grid');